import { ProfileActions } from './constants';
import { notification } from 'antd';
import { get, uniqBy } from 'lodash';

const initialState = {
  profileDataLoaded: false,
  showWarningOfLoadError: false,
  developerAvailabilityStatuses: [],
  all_certifications: [],
  all_skills: [],
  all_countries: [],
  userAvailability: null,
  current_availability_status: '',
  disabledEditAvailability: false,
  jobRoles: [],
  salaryType: 3,
  rate_config: [],
  rate_config_date: null,
  personal_info: {
    phone_number: null,
    phone_country_code: null,
    full_name: null,
    first_name: null,
    last_name: null,
    resume: null,
    avatar: null,
    email: null,
    country: null,
    role_type_id: null,
    verbal_communication: null,
    years_of_experience: null,
    years_of_working_remotely: null,
    expected_salary_amount_yearly: null,
    salary_local_currency: null,
    time_from: {},
    linkedin_url: null,
    github_url: null,
    summary: null,
    code: null,
    availability_status_id: null,
    starts_in_weeks: null
  },
  projects_info: [],
  education_info: [],
  certification_info: [],
  skills_info: [],
  parsed_skills: [],
  publication_info: [],
  experience_info: [],
  loading: false,
  profileDataLoadedCounter: 0
};

const openNotification = (type, title, description) => {
  notification[type]({
    message: title,
    description: description,
    duration: 5
  });
};

function ProfileReducer (state = initialState, action) {
  const { type = '', payload = null } = { ...action };
  switch (type) {
    case ProfileActions.LOADING_PROFILE_DATA: {
      return { ...state, loading: true, showWarningOfLoadError: false };
    }
    case ProfileActions.LOAD_PROFILE_DATA_SUCCESS: {
      // Yes, Is not the good way the extracting of first_name and last_name from full_name
      // but we are obliged as long as we save the full_name in user table
      if (payload && payload.personal_info) {
        const full_name = (get(payload, 'personal_info.full_name', '') || '').trim().split(' ');
        if (full_name.length && payload && typeof payload.personal_info === 'object') {
          payload.personal_info.first_name = full_name.shift();
          payload.personal_info.last_name = full_name.join(' ');
        }
      }

      if (payload && Array.isArray(payload.skills_info)) {
        payload.skills_info = uniqBy(payload.skills_info, 'skill_id');
      }

      return {
        ...state,
        ...payload,
        loading: false,
        profileDataLoaded: true,
        showWarningOfLoadError: false,
        /* hop.t: I ADDED THIS FLAG TO ONLY RE-CALCULATE THE INFO IN Profile.js TO PREVENT
        THE info OBJECT CALCULATION IN EVERY RENDERS
        CURRENTLY ALL THE COMPONENTS RE-RENDER IN EVERY CHANGE IN ANY OTHER COMPONENT */
        profileDataLoadedCounter: (action.firstProfileLoaded || state.profileDataLoadedCounter > 0) ? state.profileDataLoadedCounter + 1 : 0
      };
    }
    case ProfileActions.LOAD_PROFILE_DATA_FAILED: {
      if (payload && payload.message) {
        openNotification('error', payload.message);
      }
      return { ...state, loading: false, showWarningOfLoadError: true };
    }
    case ProfileActions.LOAD_PARSED_RESUME_DATA_SUCCESS: {
      const personal_info = state.personal_info || {};

      if (!personal_info.first_name) {
        personal_info.first_name = get(payload, 'personName.firstName', '') || '';
      }

      if (!personal_info.last_name) {
        personal_info.last_name = get(payload, 'personName.lastName', '') || '';
      }

      if (!personal_info.full_name) {
        personal_info.full_name = `${personal_info.first_name} ${personal_info.last_name}`.trim();
      }

      if (!personal_info.phone_country_code) {
        personal_info.phone_country_code = get(payload, 'country.code', '') || '';
      }

      if (!personal_info.country_citizenship) {
        personal_info.country_citizenship = get(payload, 'country.name', '') || '';
      }

      if (!personal_info.country) {
        personal_info.country = get(payload, 'country.name', '') || '';
        personal_info.code = get(payload, 'country.code', '') || '';
      }

      const parsed_skills = get(payload, 'skills', []) || [];

      return { ...state, personal_info, parsed_skills };
    }
    case ProfileActions.SET_USER_AVAILABILITY: {
      return { ...state, ...payload };
    }
    case ProfileActions.END_LOADING: {
      return { ...state, loading: false };
    }
    case ProfileActions.SET_PHONE_COUNTRY: {
      const personalInfoObj = { ...state.personal_info, phone_country_code: payload };
      return { ...state, personal_info: personalInfoObj };
    }
    default:
      return { ...state, profileDataLoadedCounter: 0 };
  }
}

export default ProfileReducer;
